import React, { useEffect, useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { getImageUrl } from '../utils/cdnUtils'
import { CUSTOMER_SLIP_CANCEL_WINDOW_MINUTES, formatCustomerSlipCancelWindowText, type LotteryRound, lotteryService } from '../services/lotteryService'
import RulesGuideModal from '../components/RulesGuideModal'

const SetTermsPage: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [showModal, setShowModal] = useState(false)
  const [cancelWindowMinutes, setCancelWindowMinutes] = useState(CUSTOMER_SLIP_CANCEL_WINDOW_MINUTES)
  const round = (location.state as { round?: LotteryRound } | null)?.round
  const displayName = round?.huayName ?? 'หวยลาวชุด'
  const closeTime = round?.betEndTime
    ? new Date(round.betEndTime).toLocaleString('th-TH', {
        timeZone: 'Asia/Bangkok',
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    : '23-Aug-2024 20:15'

  useEffect(() => {
    let isMounted = true
    void lotteryService.getCustomerSlipCancelWindowMinutes().then((minutes) => {
      if (isMounted) setCancelWindowMinutes(minutes)
    })
    return () => {
      isMounted = false
    }
  }, [])

  return (
    <div className="content pb-3">
      <div className="container">
        <div className="row px--1">
          <div className="col-12 px-1">
            <div className="bdr-5 bx-sd mb-2">
              <div className="row mx--1">
                <div className="col-12 px-1">
                  <div className="w-100 p-2 bgc-4 wrap justify-content-between">
                    <a 
                      href="#"
                      className="txt-link-d"
                      onClick={() => navigate('/set')}
                    >
                      <i className="fas fa-chevron-left me-1"></i>
                      หน้าแทงหวย
                    </a>

                    <a
                      href="#"
                      className="bdr-5 c-white bgg-4 txt-link px-2"
                      onClick={(e) => {
                        e.preventDefault()
                        setShowModal(true)
                      }}
                    >
                      กติกา & วิธีเล่น
                    </a>
                  </div>
                </div>

                <div className="col-12 px-1">
                  <div className="w-100 p-2 bgc-7">
                    <div className="bdr-5 bgc-4 c-red px-2 py-1 wrap justify-content-between">
                      <div className="wrap">
                        <div className="icon-f">
                          <img src={getImageUrl('flag/la.png')} alt="" />
                        </div>
                        <p className="mx-2 fs-18 t-medium">{displayName}</p>
                      </div>
                      <div className="bgc-9 bdr-5 py-1 px-2 c-white wrap justify-content-center">
                        <small>{closeTime}</small>
                      </div>
                    </div>

                    <div className="row mx--1">
                      <div className="col-12 col-md-4 px-1 mt-2">
                        <a
                          href="#"
                          className="bgg-1 p-1 bdr-5 text-center box-hover"
                          onClick={(e) => {
                            e.preventDefault()
                            navigate('/set-lotto-game', { state: { round, packageCode: 'SET_LARGE', fixedPrice: 120 } })
                          }}
                        >
                          <div className="bgc-4 bdr-5 p-1 t-regular c-red">
                            <h5>ชุดใหญ่</h5>
                          </div>
                          <div className="px-1 py-2 c-white">
                            <h5>ราคา 120 บ.</h5>
                            <h6 className="c-main wrap align-items-start justify-content-center">
                              จ่าย
                              <span className="txt-st t-medium px-2">130,000</span>
                              บาท
                            </h6>
                            <h5>ลด 0%</h5>
                          </div>
                        </a>
                      </div>

                      <div className="col-12 col-md-4 px-1 mt-2">
                        <a
                          href="#"
                          className="bgg-1 p-1 bdr-5 text-center box-hover"
                          onClick={(e) => {
                            e.preventDefault()
                            navigate('/set-lotto-game', { state: { round, packageCode: 'SET_MEDIUM', fixedPrice: 60 } })
                          }}
                        >
                          <div className="bgc-4 bdr-5 p-1 t-regular c-red">
                            <h5>ชุดกลาง</h5>
                          </div>
                          <div className="px-1 py-2 c-white">
                            <h5>ราคา 60 บ.</h5>
                            <h6 className="c-main wrap align-items-start justify-content-center">
                              จ่าย
                              <span className="txt-st t-medium px-2">60,000</span>
                              บาท
                            </h6>
                            <h5>ลด 0%</h5>
                          </div>
                        </a>
                      </div>

                      <div className="col-12 col-md-4 px-1 mt-2">
                        <a
                          href="#"
                          className="bgg-1 p-1 bdr-5 text-center box-hover"
                          onClick={(e) => {
                            e.preventDefault()
                            navigate('/set-lotto-game', { state: { round, packageCode: 'SET_SMALL', fixedPrice: 30 } })
                          }}
                        >
                          <div className="bgc-4 bdr-5 p-1 t-regular c-red">
                            <h5>ชุดเล็ก</h5>
                          </div>
                          <div className="px-1 py-2 c-white">
                            <h5>ราคา 30 บ.</h5>
                            <h6 className="c-main wrap align-items-start justify-content-center">
                              จ่าย
                              <span className="txt-st t-medium px-2">30,000</span>
                              บาท
                            </h6>
                            <h5>ลด 0%</h5>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <RulesGuideModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        scope={round ? {
          huayId: round.huayId,
          huayName: round.huayName,
          huayTypeId: round.huayTypeId,
          huayTypeName: round.huayTypeName,
        } : undefined}
        closeButtonLabel="ยอมรับและตกลง"
        fallbackRules={(
          <div className="text-center">
            <p>- ระบบเปิด-ปิดแทงตามเวลาที่ได้แจ้งไว้ และบริษัทสามารถพิจารณาปิดแทงก่อนกำหนดได้</p>
            <p>- ทางบริษัทสามารถคืนเลขได้ทุกกรณี แต่จะคืนก่อนที่จะออกผลรางวัล</p>
            <p>- การคืนเลขหรือคืนโพยของสมาชิก ต้องเป็นไปเงื่อนไขและเวลาที่ทางเว็บกำหนดเท่านั้น (<span style={{ color: '#ff0000' }}><strong>คืนโพยได้ภายใน {formatCustomerSlipCancelWindowText(cancelWindowMinutes)}หลังจากที่แทง</strong></span>)</p>
            <p>- หากหวยนั้นๆ มีการออกผลรางวัลก่อนที่จะปิดแทง บริษัทจะทำการยกเลิกรายการที่แทงเฉพาะบางเลขที่ได้ทำการแทงหลังจากหวยนั้นๆ ออกผล</p>
            <p>- ราคาจ่ายและส่วนลดจะลดลงตามเลขดังหรือเลขอั้น ให้สมาชิกตรวจสอบโพยและราคาจ่าย/ส่วนลดหลังการแทงทุกครั้ง</p>
            <p>- การสมัครสมาชิกหรือแนะนำชื่อตัวเองเพื่อปั่นค่าคอมมิชชั้น จะถูกพิจารณาปิดบัญชีและยึดเครดิตของบัญชีที่เกี่ยข้องทั้งหมด</p>
            <p>- สมาชิกที่จงใจเจตนาทุจริตในการเล่น จะถูกปิดบัญชีและไม่คืนเครดิตให้ทุกกรณี</p>
            <p>- กรณีที่เซฟเวอร์หรืออินเตอร์เน็ตล่มในช่วงการเปิดรับแทง และเกิดข้อโต้แย้งเกี่ยวกับการออกผลรางวัล ทางบริษัทมีสิทธิ์จะพิจารณายกเลิกรายการงวดและคืนเครดิตให้ลูกค้า</p>
            <p>- ผลรางวัลคลุมเครือหรือมีแนวโน้มที่ไม่โปร่งใส่ ทางบริษัทจะพิจารณายกเลิกรายการงวดและคืนเครดิตให้ลูกค้า</p>
            <p>- ในกรณีเกิดข้อพิพาทและโต้แย้งในการออกผลรางวัล การตัดสินของบริษัทถือเป็นข้อยุติและสิ้นสุด</p>
            <p>- <span style={{ color: '#ff0000' }}>สมาชิกที่สมัครมากกว่า 1 ยูสเซอร์ โดยใช้ชื่อเดียวกัน เพื่อผลประโยชน์ในการแทงได้มากกว่าหรือปั่นค่าแนะนำ จะถูกระงับและไม่คืนเครดิตให้ทุกรณี</span></p>
          </div>
        )}
        fallbackGuides={(
          <div className="mt-5">
            <p className="text-center"><strong><u>วิธีการดูผลรางวัล "หวยลาวชุด"</u></strong></p>
            <p className="text-center">ใช้รางวัลผลหวยของหวยลาว เช่น 5938</p>
            <p className="mb-4"><strong><u>การตรวจผลรางวัล</u></strong></p>
            <div className="table-responsive">
              <table className="table table-hover mb-0">
                <tbody>
                  <tr><td style={{ width: '100px' }}>4 ตัวบน</td><td>5938</td></tr>
                  <tr><td>3 ตัวตรง</td><td>938</td></tr>
                  <tr><td>4 ตัวโต๊ด</td><td>5938 สลับตำแน่งทั้ง 4 หลัก</td></tr>
                  <tr><td>3 ตัวโต๊ด</td><td>938 983 398 389 893 839</td></tr>
                  <tr><td>2 ตัวหน้า</td><td>59</td></tr>
                  <tr><td>2 ตัวหลัง</td><td>38</td></tr>
                </tbody>
              </table>
            </div>
            <p className="mt-4 text-center">**จำกัดสิทธิ์ 1 ชุดรับรางวัลใหญ่ที่สุด รางวัลเดียว**</p>
          </div>
        )}
      />
    </div>
  )
}

export default SetTermsPage
